//import
import './build/setVers.js';
import './build/anchor.js';
import './build/pagetop.js';
import './build/HeaderNavigation.js';

import { createApp } from 'vue';

/**============================================================
*   [ExternalLink]
*   description : 外部リンクやISI内別サイトを別窓で開く
============================================================*/
document.addEventListener('DOMContentLoaded', function() {
  // ページのURLからドキュメントルートから2階層目のパスを取得
  const basePath = window.location.pathname.split('/').slice(0, 3).join('/');
  // すべてのa要素を取得
  const links = document.querySelectorAll('a');
  // 各リンクに対して処理を行う
  links.forEach(function(link) {
    // もしすでにtarget属性が設定されていなければ処理を行う
    if (!link.hasAttribute('target')) {
      // リンクのhref属性値を取得
      const href = link.getAttribute('href');
      let directory = '';
      if(href) {
        if(href.startsWith('http')) {
          if(!href.includes(window.location.hostname)) {// 外部ドメインのURLかどうかをチェック
            link.setAttribute('target', '_blank');
          }else {
            directory = new URL(href).pathname.split('/').slice(0, 3)[1];
            if(!basePath.includes(directory)) {// ドキュメントルートから2階層目のパスを含まないURLかどうかをチェック
              link.setAttribute('target', '_blank');
            }
          }
        }else if(href.startsWith('/')) {
          directory = href.split('/').slice(0, 2)[1];
          if(!basePath.includes(directory)) {// ドキュメントルートから2階層目のパスを含まないURLかどうかをチェック
            link.setAttribute('target', '_blank');
          }
        }
      }
    }
  });
});

/**============================================================
*   [plugin] tableスクロールヒント
============================================================*/
import ScrollHint from 'scroll-hint';
new ScrollHint('.js-scrollable', {
  i18n: {
    scrollable: 'スクロールできます'
  }
});

/**============================================================
*   [viewport] 420px以下画面は縮小
============================================================*/
(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth >= 420
        ? 'width=device-width,initial-scale=1'
        : 'width=420';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  const mqlViewport = window.matchMedia('(min-width: 420px)');
  switchViewport(mqlViewport);
  mqlViewport.addEventListener('change', switchViewport, false);
})();

/**============================================================
*   [Animation] hover前後アニメーション別設定用クラス
*   target : .js-change-hovered
============================================================*/
const changeHoverElem = document.getElementsByClassName('js-change-hovered');
const observeChangeHover = () => {
  if (!changeHoverElem.length) return;
  [...changeHoverElem].forEach(elem => {
    elem.addEventListener('mouseover', (e)=> {
      e.target.classList.add('is-hovered');
    });
  })
}
document.addEventListener('DOMContentLoaded', observeChangeHover, false);

/**============================================================
*   [Animation] observerでアニメーション用クラス付与
*   target : .p-animation-observer
============================================================*/
import observerShowObj from './build/observerShowObj';
const observerElem = document.getElementsByClassName('p-animation-observer');
const createObserveObj = () => {
  if (!observerElem.length) return;
  for (let i = 0; i < observerElem.length; i++) {
    new observerShowObj(observerElem[i]);
  }
}
document.addEventListener('DOMContentLoaded', createObserveObj, false);

/**============================================================
*   [共通] 高さ揃え
*   targetコンテナ : js-fix-height-box
============================================================*/
import FixHeightBox from './build/FixHeightBox';
const FixHeightBoxElem = document.getElementsByClassName('js-fix-height-box');
const createFixHeightBoxObj = () => {
  if (!FixHeightBoxElem.length) return;
  for (let i = 0; i < FixHeightBoxElem.length; i++) {
    new FixHeightBox(FixHeightBoxElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createFixHeightBoxObj, false);


 /**============================================================
*   [MicroModal] + YouTubeのiframe読み込み
 ============================================================*/
//IFrame Player API の読み込み
var tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

//YouTubeの埋め込み
function onYouTubeIframeAPIReady(container,movieId) {
  new YT.Player(container, {
    width: 1120,//560
    height: 630,//315
    videoId: movieId,
    enablejsapi: 1,
    playerVars: {
      rel: 0, //再生動画と同じチャンネルから関連動画を選択
      modestbranding: 1, //YouTubeロゴを表示しない
      'origin': 'https://localhost:8001'
    }
  });
}
//micromodalの設定
import MicroModal from 'micromodal';
const micromodalSettings = {
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
  onShow: (e,t,t2)=>{
    document.documentElement.classList.add('is-modal-opened');
    const target = t2.target;
    if(e.querySelector('.scroll-hint-icon-wrap')) {
      e.querySelector('.scroll-hint-icon-wrap').classList.add('is-active');
    }

    //movieの場合
    if(target.dataset.movieUrl) {
      let movieInfo = getYoutubeInfo(target.dataset.movieUrl);
      let movieIframe = document.createElement('div'); // 要素作成
      movieIframe.setAttribute('id','m-'+movieInfo.id); // 要素にidを設定

      //縦長の場合はiframeの比率変更用クラス付与
      if(movieInfo.isShort == true) {
        movieIframe.setAttribute('class','is-portrait');
        document.getElementById('modal-movie__container').classList.add('is-movie-portrait');
      }
      document.getElementById('modal-movie-iframe').append(movieIframe);
      onYouTubeIframeAPIReady('m-'+movieInfo.id, movieInfo.id);

    }
    document.dispatchEvent(new CustomEvent('modalOpen'));
  },
  onClose: (e)=>{
    document.documentElement.classList.remove('is-modal-opened');
    //表示した動画iframeはDOMごと削除
    if(e) {
      for(const element of document.querySelectorAll('.p-micro-modal__container iframe')) {
        if(element.id.startsWith('m-')) {
          element.remove();
        }
      }
    }
    document.dispatchEvent(new CustomEvent('modalClose'));
  }
};
//data属性のURLからIDを抽出
function getYoutubeInfo(url) {
  // 通常の動画のURLの場合
  //URLサンプル
  //https://www.youtube.com/watch?v=bHQqvYy5KYo
  //https://www.youtube.com/watch?v=bHQqvYy5KYo&t=3s
  if (url.startsWith('https://www.youtube.com/watch?v=')) {
    const id = url.split('=')[1].split('?')[0];
    const isShort = false;
    return {
      id,
      isShort,
    };
  }
  // ショート用動画のURLの場合
  //URLサンプル
  //https://www.youtube.com/shorts/QcDWiB3J1zo?feature=share
  else if (url.includes('/shorts/')) {
    const id = url.split('/')[4].split('?')[0];
    const isShort = true;
    return {
      id,
      isShort,
    };
  }
  // 共有URLの場合
  //URLサンプル
  //https://youtu.be/bHQqvYy5KYo?si=PoBm-JcApV6M38zc&t=3
  //https://youtube.com/shorts/QcDWiB3J1zo?si=P3AfpmeoYPNJHU8Z
  else if (url.startsWith('https://youtu.be/')) {
    let id = url.split('/')[3].split('?')[0];
    const isShort = false;
    return {
      id,
      isShort,
    };
  }
  // その他
  else {
    return null;
  }
}

//micromodal実行
MicroModal.init(micromodalSettings);

//イベント発行があった場合は再度実行（主にSwiper）
document.addEventListener('objInit', () => {
  let modalTimer;
  clearTimeout(modalTimer);
  modalTimer = setTimeout(() => {
    MicroModal.init(micromodalSettings);
  }, 200);
});

/**============================================================
*   [共通] パネル型記事スライダー
*   target : .p-archive-slider
============================================================*/
import ArchiveSlider from './build/ArchiveSlider';
const ArchiveSliderElem = document.getElementsByClassName('p-archive-slider');
const createArchiveSliderObj = () => {
  if (!ArchiveSliderElem.length) return;
  for (let i = 0; i < ArchiveSliderElem.length; i++) {
    new ArchiveSlider(ArchiveSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createArchiveSliderObj, false);

/**============================================================
*   [共通] コンテンツスライダー
*   target : .p-contents-slider
============================================================*/
import ContentsSlider from './build/ContentsSlider';
const ContentsSliderElem = document.getElementsByClassName('p-contents-slider');
const createContentsSliderObj = () => {
  if (!ContentsSliderElem.length) return;
  for (let i = 0; i < ContentsSliderElem.length; i++) {
    new ContentsSlider(ContentsSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createContentsSliderObj, false);

/**============================================================
*   [記事詳細] ブロックエディタ内スライダー
*   target : .p-page-slider
============================================================*/
import PageSlider from './build/PageSlider';
const PageSliderElem = document.getElementsByClassName('p-page-slider');
const createPageSliderObj = () => {
  if (!PageSliderElem.length) return;
  for (let i = 0; i < PageSliderElem.length; i++) {
    new PageSlider(PageSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createPageSliderObj, false);

/**============================================================
*   [TOP] ニュースティッカー
*   target : .p-news-ticker
============================================================*/
import NewsTicker from './build/NewsTicker';
const NewsTickerElem = document.getElementsByClassName('p-news-ticker__body');
const createNewsTickerObj = () => {
  if (!NewsTickerElem.length) return;
  for (let i = 0; i < NewsTickerElem.length; i++) {
    new NewsTicker(NewsTickerElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createNewsTickerObj, false);

/**============================================================
*   [共通] カウントアップ
*   targetコンテナ : 親：js-count-up
*                   適用アイテム:.js-count-up__item)
============================================================*/
import CountUpNum from './build/CountUpNum';
const CountUpNumElem = document.getElementsByClassName('js-count-up');
const createCountUpNumObj = () => {
  if (!CountUpNumElem.length) return;
  for (let i = 0; i < CountUpNumElem.length; i++) {
    new CountUpNum(CountUpNumElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createCountUpNumObj, false);

/**============================================================
*   [lottie]
============================================================*/
import lottieImage from './build/lottieImage';
const lottieLoader = document.getElementsByClassName('js-lottie');
const observeLottieAnimation = () => {
    if (!lottieLoader.length) return;
    for (let i = 0; i < lottieLoader.length; i++) {
      new lottieImage(lottieLoader[i]);
    }
}
document.addEventListener('DOMContentLoaded', observeLottieAnimation, false);

/**============================================================
*   [vue]
*   description : ブログ記事
============================================================*/
import articlesVertical from './build/articlesVertical.vue';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#articles-vertical')) {
    createApp(articlesVertical).mount('#articles-vertical');
  }
});

import articlesVerticalReason from './build/articlesVerticalReason.vue';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#articles-vertical-reason')) {
    createApp(articlesVerticalReason).mount('#articles-vertical-reason');
  }
});

import voiceGlobalBusiness from './build/voiceGlobalBusiness.vue';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#voice-global-business')) {
    createApp(voiceGlobalBusiness).mount('#voice-global-business');
  }
});

import voiceWebMarketing from './build/voiceWebMarketing.vue';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#voice-web-marketing')) {
    createApp(voiceWebMarketing).mount('#voice-web-marketing');
  }
});

import voiceEnglishCareer from './build/voiceEnglishCareer.vue';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#voice-english-career')) {
    createApp(voiceEnglishCareer).mount('#voice-english-career');
  }
});

import voiceTourismHospitality from './build/voiceTourismHospitality.vue';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#voice-tourism-hospitality')) {
    createApp(voiceTourismHospitality).mount('#voice-tourism-hospitality');
  }
});

import voiceCourse from './build/voiceCourse.vue';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#voice-course')) {
    createApp(voiceCourse).mount('#voice-course');
  }
});

import instructorCourse from './build/instructorCourse.vue';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#instructor-course')) {
    createApp(instructorCourse).mount('#instructor-course');
  }
});
